// 합친 청구서(合并请款单) 대상 가르기 — 순수 함수 (崔凡 10-26)
//  · 입금 끝난 건은 합병 대상이 아니다(목록에서 빼고 견적 보충도 하지 않는다)
//  · 견적서가 없는 «미결제» 상품만 견적서를 자동으로 보충한다

export function isPaidItem (item) {
  return !!(item && (item.입금여부 || item.processStatus === '입금완료'))
}

// 건(그룹) 안의 상품이 전부 입금 끝났으면 «결제 완료 건»
export function isPaidGroup (group) {
  const items = (group && group.items) || []
  return items.length > 0 && items.every(isPaidItem)
}

// groups → { kept: 합병 대상, paidOut: 제외된 결제 완료 건 }
export function splitPaidGroups (groups) {
  const kept = []
  const paidOut = []
  ;(groups || []).forEach(g => (isPaidGroup(g) ? paidOut : kept).push(g))
  return { kept, paidOut }
}

// 건 하나에서 견적서를 보충해야 하는 상품(미결제 + 견적서 없음)
export function itemsNeedingQuotation (group) {
  return ((group && group.items) || []).filter(i => !isPaidItem(i) && !i.견적서_1688구매금액)
}
